module.exports = __webpack_public_path__ + "static/oauth-made-easy-aa07c0dcf697ee35c6d8d4dd589a8533.png";